import cPage from "./base/c-page";
// import cTab from "./base/c-tab";
import { Button, Field } from "vant";

export default {
  install(Vue) {
    Vue.component("c-page", cPage);
    // Vue.component("c-tab", cTab);
    Vue.component("van-button", Button);
    Vue.component("van-field", Field);
  },
};
